import StoreModuleUtils from 'util/storeModule/storeModuleUtils';

export default options => {
    if (!options) {
        throw new Error('storeModuleFactory needs an options object');
    }
    if (!options.name) {
        throw new Error('storeModuleFactory needs a name');
    }

    const
        storeModuleUtils = new StoreModuleUtils(options),
        _createActionName = action => `${action}${StoreModuleUtils.capitalize(options.name)}`,
        _createActionIfNeededName = action => `${action}${StoreModuleUtils.capitalize(options.name)}IfNeeded`,
        _addExtraActions = () => options.extraActions ?
            storeModuleUtils.createExtraActions() :
            {};

    return {
        reducer:                                      storeModuleUtils.reducer.bind(storeModuleUtils),
        [_createActionName('invalidate')]:            storeModuleUtils.invalidate.bind(storeModuleUtils),
        [_createActionIfNeededName('fetch')]:         storeModuleUtils.fetchIfNeeded.bind(storeModuleUtils),
        [_createActionIfNeededName('fetchInstance')]: storeModuleUtils.fetchInstanceIfNeeded.bind(storeModuleUtils),
        [_createActionName('create')]:                storeModuleUtils.create.bind(storeModuleUtils),
        [_createActionName('update')]:                storeModuleUtils.update.bind(storeModuleUtils),
        [_createActionName('delete')]:                storeModuleUtils.delete.bind(storeModuleUtils),
        [_createActionName('setEntities')]:           storeModuleUtils.setEntities.bind(storeModuleUtils),
        [_createActionName('getEntities')]:           storeModuleUtils.getEntities.bind(storeModuleUtils),
        [_createActionName('getEntity')]:             storeModuleUtils.getEntity.bind(storeModuleUtils),
        [_createActionName('clearError')]:            storeModuleUtils.clearError.bind(storeModuleUtils),
        [_createActionName('clearEntitiesError')]:    storeModuleUtils.clearEntitiesError.bind(storeModuleUtils),
        [_createActionName('clearEntityError')]:      storeModuleUtils.clearEntityError.bind(storeModuleUtils),
        [_createActionName('getDownloadUrl')]:        storeModuleUtils.getDownloadUrl.bind(storeModuleUtils),
        ..._addExtraActions()
    };
};



// WEBPACK FOOTER //
// ./src/util/storeModule/storeModuleFactory.js